Application.Forms.CustomCheckboxes = {
    ui: {
        container: '.js-custom-checkbox',
    },
    classes: {
        active: 'active',
    },
    ready: function () {

        var self = this;

        if (!(this.ui.container).length){
            return;
        }

        this.bind();

        // init
        $(this.ui.container).each(function(){
            self.update(this);
        });

    },
    bind: function(){

        var self = this;

        $(this.ui.container).on('change', function(e){
            self.update($(this).closest(self.ui.container));
        });

    },
    update: function(el){

        if ($(el).find('input:checked').length) {
            $(el).addClass(this.classes.active);
        }else{
            $(el).removeClass(this.classes.active);
        }

    }
}